module.exports = __webpack_public_path__ + "static/img/copy.93de7627.svg";